import './common'
import axios from 'axios'
import store from '~/store/store'

function streamlorEstablishmentIDHeader () {
    if (!store.state.main.odeonEstablishmentID) {
        return {}
    }

    return { 'X-Streamlor-Establishment-ID': store.state.main.odeonEstablishmentID }
}

export default {
    getTickets: (params) => axios.get('/odeon/api/v1/tickets', { params, headers: streamlorEstablishmentIDHeader() }),
    createTicket: (params) => axios.post('/odeon/api/v1/tickets', params, { headers: streamlorEstablishmentIDHeader() }),
    getTicket: (id, params) => axios.get(`/odeon/api/v1/tickets/${id}`, params, { headers: streamlorEstablishmentIDHeader() }),
    getTicketMessages: (id, params) => axios.get(`/odeon/api/v1/tickets/${id}/messages`, params, { headers: streamlorEstablishmentIDHeader() }),
    createTicketMessage: (data) => axios.post(`/odeon/api/v1/tickets/${data.TicketID}/messages`, data, { headers: streamlorEstablishmentIDHeader() }),
    createTicketAttachment: (data) => axios.post(`/odeon/api/v1/tickets/${data.TicketID}/attachments`, data, { headers: streamlorEstablishmentIDHeader() }),
    getOdeonParams: (id, params) => axios.get('/odeon-params', params, { headers: streamlorEstablishmentIDHeader() }),
    getBookstackToken: (params) => axios.get('/bookstack-token', { params, headers: streamlorEstablishmentIDHeader() }),
    getOdeonAuthToken: (data) => axios.post('/odeon/api/v1/auth-cas/token', data, { headers: streamlorEstablishmentIDHeader() }),
    postFile (file) {
        const headers = streamlorEstablishmentIDHeader()
        headers['Content-Type'] = 'multipart/form-data'
        const formData = new FormData()
        formData.append('file', file)
        return axios.post('/odeon/api/v1/upload', formData, { headers })
    }
}
